/** Roles that have full admin portal privileges (same as legacy admin). */
export function isAdminRole(role: string | null | undefined): boolean {
  const r = String(role || "").trim().toLowerCase();
  return r === "admin" || r === "superadmin";
}

export function isSuperAdminRole(role: string | null | undefined): boolean {
  return String(role || "").trim().toLowerCase() === "superadmin";
}

/** Staff roles allowed to sign in to the admin portal. */
export function isAdminPortalStaffRole(role: string | null | undefined): boolean {
  const r = String(role || "").trim().toLowerCase();
  return isAdminRole(r) || r === "instructor";
}

export function getStaffRoleDisplayName(role: string | null | undefined): string {
  const r = String(role || "").trim().toLowerCase();
  switch (r) {
    case "superadmin":
      return "Super Admin";
    case "admin":
      return "Admin";
    case "instructor":
      return "Instructor";
    case "student":
      return "Student";
    default:
      if (!r) return "";
      return r.charAt(0).toUpperCase() + r.slice(1);
  }
}
